import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'MDP',
  title: 'Wie kann ich mein Passwort ändern?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf das kleine Männchen unten links'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_MDP/DE_MDP_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf "Abmelden"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_MDP/DE_MDP_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie auf "Passwort vergessen? "'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_MDP/DE_MDP_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Geben Sie Ihre E-Mail-Adresse ein und klicken Sie auf "Absenden"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_MDP/DE_MDP_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Gehen Sie zu Ihrem E-Mail-Konto und klicken Sie auf den Link'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Legen Sie Ihr neues Passwort fest'
  }]
};
